import React from 'react'

const Modal = ({ children, onClose, title }) => {
    return (
        <div className=''>
            <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40" />
            <div id="modal-overlay" tabIndex="-1" className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 flex justify-center items-center w-full h-full z-40" onClick={onClose}>
                <div className="w-80per h-80per z-50 rounded-md border-3p bg-blue-10 dark:border-solid dark:bg-blue-450 flex flex-col animate-fade-in-drop">
                        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                {title}
                            </h3>
                            <button className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="default-modal" onClick={onClose}>
                                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                </svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                    <div className="p-4 pb-8 w-full h-full">
                            {children}
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default Modal
